export function GroupBy<T, TKey>(data: Array<T>, keyGetter: (arg: T) => TKey) : Map<TKey, Array<T>> {
    const groups = new Map<TKey, Array<T>>();
    data.forEach(datum => {
        const key = keyGetter(datum);
        if (!groups.has(key)) {
            groups.set(key, []);
        }
        groups.get(key)?.push(datum);
    });
    return groups;
}

export function Remove<T>(data: T[], removeFilter: (arg: T) => boolean) : void {
    const removeMatches = data.filter(d => removeFilter(d));
    removeMatches.forEach(r => {
        const index = data.indexOf(r);
        data.splice(index, 1);
    });
}

export function OrderBy<T>(data: T[], sortProp: (arg: T) => number) : T[] {
    const output = data.filter(t => true);
    output.sort((a,b) => sortProp(a) - sortProp(b));
    return output;
}

export function OrderByString<T>(data: T[], sortProp: (arg: T) => string) : T[] {
    const output = data.filter(t => true);
    output.sort((a,b) => sortProp(a).localeCompare(sortProp(b)));
    return output;
}